import { Button } from "@sylviq/ui-react-web/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@sylviq/ui-react-web/components/ui/card";
import { Link } from "@tanstack/react-router";
import { useEffect, useRef, useState } from "react";
import { BrandLockup } from "@/features/marketing/components/BrandLockup";
import { confirmEmail } from "@/lib/api";

type State = "working" | "verified" | "invalid";

/** Landing page for the link in the verification email (`?token=…`). */
export function VerifyEmailPage() {
  const [state, setState] = useState<State>("working");
  // The token is single-use: StrictMode's double effect must not spend it
  // twice and turn a success into "invalid".
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const token = new URLSearchParams(window.location.search).get("token");
    if (!token) {
      setState("invalid");
      return;
    }
    confirmEmail(token).then(
      () => setState("verified"),
      () => setState("invalid"),
    );
  }, []);

  return (
    <div className="mx-auto flex min-h-dvh w-full max-w-md flex-col justify-center gap-4 px-6 py-16">
      <div className="flex items-center justify-center">
        <BrandLockup className="h-14 w-14" />
      </div>
      <Card>
        <CardHeader className="justify-center text-center">
          <div>
            <CardTitle className="text-xl">
              {state === "working"
                ? "Confirming your email..."
                : state === "verified"
                  ? "Email confirmed"
                  : "Link not valid"}
            </CardTitle>
            <CardDescription>
              {state === "working"
                ? "One moment."
                : state === "verified"
                  ? "Your address is confirmed. You can sign in now."
                  : "This link has expired or was already used. Sign in and ask for a new one."}
            </CardDescription>
          </div>
        </CardHeader>
        {state === "working" ? null : (
          <CardContent>
            <Button asChild className="w-full">
              <Link to="/login">Go to sign in</Link>
            </Button>
          </CardContent>
        )}
      </Card>
    </div>
  );
}
